import {useCallback, useEffect, useState} from 'react';
import {useTheme} from 'next-themes';

export function useDarkMode() {
	const {resolvedTheme, setTheme} = useTheme();
	const [isDarkMode, setDarkMode] = useState(resolvedTheme === 'dark');

	const toggleDarkMode = useCallback(() => {
		setDarkMode((prevState) => !prevState);
	}, []);

	useEffect(() => {
		if (isDarkMode) {
			setTheme('dark');
		} else {
			setTheme('light');
		}
	}, [isDarkMode, setTheme]);

	return {isDarkMode, toggleDarkMode};
}
